import React, { useRef,useState } from 'react'
import './Quotation.css' // Import your CSS file

const Quotation = () => {
    const ref = useRef()

    const [showButton, setShowButton] = useState(true);

    const generatePdf = () => {
        // Hide the button before generating the PDF
        setShowButton(false);

        // Trigger the print functionality after a slight delay to allow the button to hide
        setTimeout(() => {
            window.print();
            // Show the button again after printing is completed (optional)
            setTimeout(() => {
                setShowButton(true);
            }, 100);
        }, 100);
    };
    return (
        <div>
            <div className='container'>
			<div class="row">
  				<div class="column1">
				  <img className='quotation_img' src="../assets/Quotation.png" alt="logo"></img>
 				</div>
  				
				<div class="column2">
					<div className='row1_column2'>
						<div className='sub_row1_column2'>
							<img className='logo_quotation' src="../assets/Qunnova.png" alt="logo"></img>
						</div>
					</div>

					<div className='row2_column2'>
						
						<table>
                <thead>
                    <tr>
                        <th>Client Details</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tr>
                    <td>Client Name</td>
                    <td>John Doe</td>
                </tr>
                <tr>
                    <td>Contact Number</td>
                    <td>123-456-7890</td>
                </tr>
            </table>

            <div ref={ref} className="quotation-details">
                <table>
                    <thead>
                        <tr>
                            <th>Particulars</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Add more rows for other client details */}

                        <tr>
                            <td>
                                Carcasses
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Number</th>
                                            <th>Product Size</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>5</td>
                                            <td>Standard</td>
                                            <td>2</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Standard</td>
                                            <td>2</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Standard</td>
                                            <td>2</td>
                                        </tr>
                                        {/* Add more rows for additional details */}
                                    </tbody>
                                </table>
                            </td>
                            <td>$200</td>
                        </tr>

                        <tr>
                            {/* Leave this row empty as the first cell is already occupied */}
                        </tr>
                        <tr>
                            <td>
                                Hardware
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Number</th>
                                            <th>Product Size</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>5</td>
                                            <td>Standard</td>
                                            <td>2</td>
                                        </tr>
                                        {/* Add more rows for additional details */}
                                    </tbody>
                                </table>
                            </td>
                            <td>$150</td>
                        </tr>
                        <tr>
                            <td>
                                Stone
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Number</th>
                                            <th>Product Size</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>5</td>
                                            <td>Standard</td>
                                            <td>2</td>
                                        </tr>
                                        {/* Add more rows for additional details */}
                                    </tbody>
                                </table>
                            </td>
                            <td>$300</td>
                        </tr>
                        {/* Add more rows for other particulars */}
                    </tbody>
                </table>
            </div>
            {showButton && <button onClick={generatePdf}>Generate PDF</button>}
					</div>
  				</div>
			</div>
			
            </div>

        </div>
    )
}

export default Quotation